import { Avatar, AvatarProps } from '@chakra-ui/react';
import IconPaper from 'assets/icons/icon-paper.svg?react';

export default function AvatarPaper(props: AvatarProps) {
  return (
    <Avatar 
      size="sm"
      icon={<IconPaper />} 
      bg="green.100"
      color="green.800"
      {...props}
    />
  )
}
